import React, {useContext, useEffect, useRef, useState} from 'react';
import './style.scss';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import {AppContext} from "../../Utils/AppContext";
import _ from "lodash";
import SendIcon from "@material-ui/icons/SendRounded";
import {CancelScheduleSend as UnableSendIcon} from "@material-ui/icons";
import Tooltip from "@material-ui/core/es/Tooltip/Tooltip";
import moment from "moment";
import Skeleton from "@material-ui/lab/Skeleton";
import {publish} from "../../../Events/events";
import {
    GroupClickedOnGroupsToolbar,
    GroupHoverOnGroupsToolbar,
    GroupHoverOutOnGroupsToolbar,
    OrderClickedOnGroup
} from "../../../Events/topics";
import LockIcon from "@material-ui/icons/Lock";
import UnlockIcon from "@material-ui/icons/LockOpen";
import IconButton from "@material-ui/core/IconButton";
import RouteStops from "./RouteStops/RouteStops";
import {Droppable} from "react-beautiful-dnd";
import RouteTimeCircle from "../../RouteTimeCircle/RouteTimeCircle";
import {secondsUntil} from "../../../Utils/TimeUtils";

export default function ProposedRoute(props) {
    const appContext = useContext(AppContext);
    const [selectedMessengerId, setSelectedMessengerId] = useState();
    const [groupColor, setGroupColor] = useState('transparent');
    const [sortedMessengers, setSortedMessengers] = useState([]);
    const [isMessengerOnActiveGroup, setIsMessengerOnActiveGroup] = useState(false);
    const [timeTillStartHumanized, setTimeTillStartHumanized] = useState("");
    const isCurrentlyHover = useRef(false);
    const [isSent, setIsSent] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isMerukazot, setIsMerukazot] = useState(false);

    useEffect(() => {
        setIsMerukazot(props.route.id.startsWith("merukazot~"));
    }, [props.route.id]);

    useEffect(() => {
        if (props.isEvaluatingDeliveryGroups)
            setLoading(true);
        else
            setLoading(false);

    }, [props.isEvaluatingDeliveryGroups]);

    useEffect(() => {
        setTimeTillStartHumanized(getHumanizedTimeTillStart());
    }, [props.assignedDeliveryGroups, isMessengerOnActiveGroup, props.route]);

    useEffect(() => {
        setIsMessengerOnActiveGroup(props.route ? checkIfMessengerOnActiveGroup(selectedMessengerId || props.route.messenger_id) : false);

        const newSortedMessengers = [...props.users || []]
            .filter(messenger => _.get(messenger, "profiles.messenger.isCurrentlyAvailable") || _.get(messenger, "profiles.messenger.isWhileMission"))
            .sort(compareMessengersByAvailabilityTime);

        setSortedMessengers(newSortedMessengers);
    }, [props.users])

    useEffect(() => {
        setIsMessengerOnActiveGroup(props.route ? checkIfMessengerOnActiveGroup(selectedMessengerId || props.route.messenger_id) : false);
    }, [selectedMessengerId])

    useEffect(() => {
        setSelectedMessengerId(props.route ? props.route.messenger_id : '');
        setIsMessengerOnActiveGroup(props.route ? checkIfMessengerOnActiveGroup(selectedMessengerId || props.route.messenger_id) : false);
        setGroupColor(appContext.iconColors.getColorByGroupId(props.route.id).primaryColor);
    }, [props.route]);

    const getHumanizedTimeTillStart = () => {
        if (isMessengerOnActiveGroup) {
            const group = getMessengerAssignedDeliveryGroup(selectedMessengerId);
            if (group && group.real_time_finish_time !== undefined) {
                if (secondsUntil(group.real_time_finish_time) > 0) {
                    const humanizedDuration = moment.duration(secondsUntil(group.real_time_finish_time) + props.route.time_till_start_since_messenger_available, 'seconds').humanize();
                    return "בעוד " + humanizedDuration;
                } else {
                    if (props.route.time_till_start_since_messenger_available === 0)
                        return "כשיחזור";
                    else {
                        const humanizedDuration = moment.duration(props.route.time_till_start_since_messenger_available, 'seconds').humanize();
                        return humanizedDuration + " לאחר שיחזור";
                    }
                }
            }
        }

        if (props.route.time_till_start > 0) {
            const humanizedDuration = getUpdatedDuration(props.route.time_till_start, props.route.timestamp).humanize();
            return "בעוד " + humanizedDuration;
        }

        return "עכשיו";
    };

    const selectMessenger = async (e, messengerId) => {
        e.stopPropagation();

        setSelectedMessengerId(messengerId);

        if (props.lockData) {
            await props.lockMessengerToGroup({
                bid: appContext.bid,
                groupId: props.route.id,
                messengerId: messengerId,
                isMessengerChanged: true
            });
        } else {
            await props.lockDeliveryGroup({
                bid: appContext.bid,
                groupId: props.route.id,
                orderIds: props.route.route.map(stop => stop.order_id),
                messengerId: messengerId,
                isOrdered: true,
                isMessengerChanged: true
            });
        }
    };

    const onRemoveStopFromRouteClick = (e, stopId) => {
        if (props.onRemoveStopFromRouteClick)
            props.onRemoveStopFromRouteClick(stopId);
    };

    const onStopDoubleClick = (e, stopId) => {
        if (props.onStopDoubleClick)
            props.onStopDoubleClick(stopId);
    };

    const onStopClick = (e, stopId) => {
        if (props.onStopClick)
            props.onStopClick(stopId);

        publish(OrderClickedOnGroup, {orderId: stopId});
    };

    const onStopHover = (e, stopId) => {
        publish(GroupHoverOnGroupsToolbar, {orderIds: [stopId]});
    };

    const onStopHoverOut = (e) => {
        const orderIds = props.route.route.map(stop => stop.order_id);

        publish(GroupHoverOnGroupsToolbar, {orderIds: orderIds});
    };

    const onRouteHover = (e) => {
        if (!isCurrentlyHover.current) {
            const orderIds = props.route.route.map(stop => stop.order_id);

            publish(GroupHoverOnGroupsToolbar, {orderIds: orderIds});

            isCurrentlyHover.current = true;
        }
    };

    const onRouteHoverOut = (e) => {
        const orderIds = props.route.route.map(stop => stop.order_id);

        publish(GroupHoverOutOnGroupsToolbar, {orderIds: orderIds});

        isCurrentlyHover.current = false;
    };

    const onRouteClicked = (e) => {
        if (e.defaultPrevented)
            return;

        const orderIds = props.route.route.map(stop => stop.order_id);

        publish(GroupClickedOnGroupsToolbar, {orderIds: orderIds});
    };

    const compareMessengersByAvailabilityTime = (a, b) => {
        const aLastAvailable = _.get(a, "profiles.messenger.lastAvailableTimestamp", '0');
        const aLastNonAvailable = _.get(a, "profiles.messenger.lastNonAvailableTimestamp", '0');

        const bLastAvailable = _.get(b, "profiles.messenger.lastAvailableTimestamp", '0');
        const bLastNonAvailable = _.get(b, "profiles.messenger.lastNonAvailableTimestamp", '0');

        const aTimestamp = aLastAvailable > aLastNonAvailable ? aLastAvailable : aLastNonAvailable;
        const bTimestamp = bLastAvailable > bLastNonAvailable ? bLastAvailable : bLastNonAvailable;

        if (aTimestamp < bTimestamp)
            return -1;
        else if (aTimestamp > bTimestamp)
            return 1;

        return 0;
    };

    const getUpdatedDuration = (duration, timestamp) => {
        const orderDuration = moment.duration(duration, 'seconds');
        const now = moment();
        const evaluationTime = moment(timestamp);
        const secondsPassed = now.diff(evaluationTime, 'seconds');

        return orderDuration.subtract(secondsPassed, 'seconds');
    };

    const onSend = async (e) => {
        e.stopPropagation();

        if (isMessengerOnActiveGroup)
            return;

        const groupData = {
            ...props.route,
            timestamp: new Date().toISOString(),
            status: "ASSIGNED",
            bid: appContext.bid,
            messenger_id: selectedMessengerId
        };

        setIsSent(true);

        await props.sendDeliveryGroup(groupData);
        props.fetchDeliveryGroups(appContext.bid);
    };

    const checkIfMessengerOnActiveGroup = (mId) => {
        return props.users.find(user => user.id === mId)?.profiles?.messenger?.isWhileMission;
    };

    const getMessengerAssignedDeliveryGroup = (mId) => {
        return props.assignedDeliveryGroups.find(g => g.messenger_id === mId);
    };

    const onLockRouteClicked = async (e) => {
        e.stopPropagation();

        if (props.lockData) {
            await props.unlockDeliveryGroup({
                bid: appContext.bid,
                groupId: props.route.id
            });
        } else {
            props.lockDeliveryGroup({
                bid: appContext.bid,
                groupId: props.route.id,
                orderIds: props.route.route.map(order => order.order_id),
                isOrdered: true
            });
        }
    };

    const onLockMessengerClicked = async (e) => {
        e.stopPropagation();

        if (props.lockData && props.lockData.messenger_id) {
            await props.unlockMessengerFromGroup({
                bid: appContext.bid,
                groupId: props.route.id
            });
        } else
            props.lockMessengerToGroup({
                bid: appContext.bid,
                groupId: props.route.id,
                messengerId: selectedMessengerId
            });
    };

    const showBackgroundLoader = isLoading || isSent;

    return (
        <Droppable droppableId={`route-${props.route.id}`}>
            {(provided, snapshot) => {
                let isDraggingFromOutside = false;

                if (snapshot.isDraggingOver) {
                    const orderId = snapshot.draggingOverWith.replace("stop-", "")

                    if (!props.route.route.map(s => s.order_id).includes(orderId))
                        isDraggingFromOutside = true;
                }

                return (
                    <div
                        className={"proposed-route"
                            + (isMessengerOnActiveGroup ? " proposed-route-messenger-used" : "")
                            + (props.lockData ? " proposed-route-locked" : "")
                            + (showBackgroundLoader ? " proposed-route-loading" : "")}
                        ref={provided.innerRef} {...provided.droppableProps}
                        onMouseOver={onRouteHover}
                        onMouseLeave={onRouteHoverOut}>
                        {
                            showBackgroundLoader ?
                                <div className="background-loader">
                                    <Skeleton animation="wave"/>
                                </div>
                                :
                                null
                        }
                        <div
                            className="proposed-route-content"
                            onClick={onRouteClicked}
                            style={{border: `6px solid ${groupColor}`}}>
                            <div className="side-buttons">
                                <IconButton disabled={showBackgroundLoader}
                                            className={props.lockData || isMerukazot ? "unlock-route-button" : "lock-route-button"}
                                            onClick={onLockRouteClicked}
                                            size="small">
                                    {props.lockData || isMerukazot ?
                                        <LockIcon fontSize="small"/>
                                        :
                                        <UnlockIcon fontSize="small"/>
                                    }
                                </IconButton>
                            </div>
                            <div className="route-info">
                                <div className="route-info-content">
                                    <div className="top-section">
                                        <div className="messenger-info">
                                            <div className="messenger-select-container">
                                                <Select
                                                    onChange={(e) => selectMessenger(e, e.target.value)}
                                                    value={selectedMessengerId || ""}>
                                                    {
                                                        sortedMessengers.map((messenger, index) =>
                                                            <MenuItem
                                                                key={`group-messenger-${messenger.id}`}
                                                                value={messenger.id}>{messenger.name}</MenuItem>
                                                        )
                                                    }
                                                </Select>
                                                <IconButton
                                                    className={"unlock-lock-messenger-button" + (!props.lockData ? " unlock-lock-messenger-button-hidden" : (props.lockData.messenger_id ? " unlock-messenger-button" : " lock-messenger-button"))}
                                                    onClick={onLockMessengerClicked}
                                                    size="small">
                                                    {
                                                        !props.lockData || props.lockData.messenger_id ?
                                                            <LockIcon fontSize="small"/>
                                                            :
                                                            <UnlockIcon fontSize="small"/>
                                                    }
                                                </IconButton>
                                            </div>
                                            <div className="messenger-time-till-start">
                                                {timeTillStartHumanized}
                                            </div>
                                        </div>
                                        <span className="route-time-circle-wrapper">
                                            <RouteTimeCircle status="PROPOSED"
                                                             totalDuration={props.route.duration}/>
                                        </span>
                                    </div>
                                    <div className="route">
                                        <RouteStops routeId={props.route.id}
                                                    stops={props.route.route}
                                                    onStopDoubleClick={onStopDoubleClick}
                                                    onRemoveStopFromRouteClick={onRemoveStopFromRouteClick}
                                                    onStopClick={onStopClick}
                                                    onStopHover={onStopHover}
                                                    onStopHoverOut={onStopHoverOut}
                                                    isDraggingFromOutside={isDraggingFromOutside}
                                                    placeholder={provided.placeholder}
                                                    drag={props.drag}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="route-send-container" onClick={onSend}>
                                <Tooltip
                                    disableTouchListener={!isMessengerOnActiveGroup}
                                    disableHoverListener={!isMessengerOnActiveGroup}
                                    arrow
                                    enterTouchDelay={0}
                                    title={isMessengerOnActiveGroup ? "השליח במהלך משימה אחרת" : ""}>
                                    <div className="send-icon-container">
                                        {
                                            isMessengerOnActiveGroup ?
                                                <UnableSendIcon fontSize="small"/>
                                                :
                                                <SendIcon fontSize="small"/>
                                        }
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                );
            }}
        </Droppable>
    );
}